import React, { useMemo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import {
  GeneralSelect,
  OptionType,
} from 'v2/form/CustomSelectors/GeneralSelect';
import { CustomAIChat, DjangoListResponse } from 'v2/models';
import { AISearchFormFields } from './AISearchSchema';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import { AISearchRequiresFiles } from 'v2/utils/AISearchUtils';
import { useQuery } from 'react-query';
import restFactory from 'v2/utils/restFactory';

const AICustomChatFormField = () => {
  const { control } = useFormContext<AISearchFormFields>();
  const defaultPreset = 'Default preset';
  const searchType = useWatch({ control, name: 'searchType' });

  const { data: customChatsData } = useQuery(
    ['Custom_AIChats'],
    async () =>
      await restFactory.get<DjangoListResponse<CustomAIChat>>(
        `/dj/api/v1/custom_chat/`,
        { size: 50 }
      ),
    { cacheTime: 0 }
  );

  const customChats = useMemo(
    () => customChatsData?.results || [],
    [customChatsData]
  );

  if (!AISearchRequiresFiles[searchType]) {
    return null;
  }

  if (!customChats.length) {
    return null;
  }

  const options: OptionType[] = [
    { label: defaultPreset, value: '' },
    ...customChats.map(({ id, name }) => ({
      label: name,
      value: id,
    })),
  ];

  return (
    <>
      <FormLabel
        label={`What chat preset would you like to use?`}
        required={false}
        className={'mt-4'}
      />
      <Controller
        name="customChat"
        control={control}
        rules={{
          required: false,
        }}
        render={({ field: { onChange } }) => {
          return (
            <GeneralSelect
              options={options}
              handleChange={(option) => onChange(option?.value)}
              placeHolder={defaultPreset}
              customStyles={{
                control: {
                  width: '100%',
                  borderColor: 'var(--light-gray)',
                  cursor: 'pointer',
                },
                dropdownIndicator: {
                  right: '10px',
                  justifyContent: 'flex-end',
                },
              }}
            />
          );
        }}
      />
    </>
  );
};

export default AICustomChatFormField;
